import { AxiosResponse } from 'axios';
import Api from '../api';
import { ModuleType } from '../modules.types';

const CreateApi = ({
  moduleType,
  data,
}: {
  moduleType: ModuleType;
  data: any;
}): Promise<AxiosResponse> => {
  const path = `/admin/${moduleType}/create`;
  return Api.getInstance().request.post(path, data);
};
export default CreateApi;
